import { LOGO_FAG, LOGO_INA } from "../../utils/url/staticResources";

type LogoProps = Omit<JSX.IntrinsicElements["img"], "src" | "alt">;
const FAG = (props: LogoProps) => <img src={LOGO_FAG} alt="FAG logo" {...props} />;
const INA = (props: LogoProps) => <img src={LOGO_INA} alt="INA logo" {...props} />;

export const Logos = {
  INA,
  FAG,
};
